import base from './base'

const TRADINGVIEW_STYLE = {
  bg: '#12161C',
  grid: '#333',
  lineColor: '#28343C',
  short: '#ea0070',
  shortFill: '#ea0070',
  long: '#00C087',
  longFill: '#00C087',
  crosshair: '#626c73',
  cta: '#363D52',
  ctaHighlight: '#414A67',
  alert: '#FFD506',
  category: 'dark',
  textColor: '#999',
  maLine: '#f5bc00',
  ma1: '#ffc200',
  ma2: '#ff00ff',
  ma3: '#cc0066',
}

const tradingViewStyle = TRADINGVIEW_STYLE

export default {
  ...base,
  mode: 'DARK',
  // exchangeMainBg: '#0B0E11',
  exchangeMainBg: '#000',
  exchangeSecondBg: '#12161C',
  exchangeHeadShadow: '1px 3px 5px 0px rgba(11, 14, 17, 1)',
  exchangeTradePairSearchBg: 'rgba(37, 45, 56, 0.4)',
  exchangeCommonNumberColor: '#fff',
  exchangeIncrementButtonBorderColor: 'transparent',
  exchangeButtonBorderColor: 'transparent',
  exchangeButtonHoverBg: 'rgba(240, 185, 11, 0.15)',
  exchangeMaxAmountBgColor: '#f0b90b',
  exchangeMaxAmountColor: '#263147',
  exchangeTitleColor: '#848e9c',
  exchangeIconColor: '#959EB1',
  qrcodeBg: '#252D38',
  exchangeTableTitle: '#48515d',
  exchangeFilterBg: 'rgba(37,45,56,0.4)',
  headerBg: '#12161C',
  headerDropdownBg: '#252D38',
  headerDropdownItemHoverBg: '#212833',
  headerItemHoverBg: 'rgba(33, 40, 51, 0.5)',
  userMenuAddressBg: 'rgba(255, 255, 255, 0.05)',
  userMenuAddressTextColor: 'rgba(255, 255, 255, 0.3)',
  calendarButtonEnable: '#848E9C',
  calendarButtonDisable: '#48515D',
  dropdownBg: '#252D38',
  dropdownItemColor: '#fff',
  dropdownSelectBgColor: 'rgb(33, 40, 51)',
  dropdownSelectItemColor: '#fff',
  dropdownTextDisplayColor: '#fff',
  popupBg: '#252D38',
  menuItemBg: '#252D38',
  fiatPriceColor: '#d4d4d4',
  TxHashColor: '#848E9C',
  CheckBoxLabelColor: '#848E9C',
  thColor: '#48515D',
  bg1: '#1A2132',
  bg2: '#212833',
  inputBgColor: '#252D38',
  inputColor: '#fff',
  boxbg: '#252D38',
  borderColor: '#212833',
  selcetItemColor: '#1A2132',
  border: '#333',
  border1: '#333',
  activeBorder: '#f3ba2f',
  boxShadow: '0px 3px 10px 0px rgba(0, 0, 0, 0.5)',
  scrollTableHDBoxShadow: '0px 3px 10px 0px rgba(0, 0, 0, 0.5)',
  toolTipBoxShadow: '0 0 12px rgba(0,0,0,.175)',
  activeBg: '#1d1d1d',
  tabBorderColor: '#48515D',
  tabBg: '#1d1d1d',
  buttonbg: '#1d1d1d',
  buttonbgactive: '#f0b90b',
  buttonbgdisabled: '#ddd',
  chartbuttonbg: '#12161C',
  chartButtonColorActive: '#fff',
  buttonColorActive: '#f5bc00',
  okButtonBg: '#f0b90b',
  buttonGradient: 'linear-gradient(90deg, rgba(239, 184, 11, 1) 0%, rgba(251, 218, 60, 1) 100%)',
  cancelButtonBg: '#666',
  up: '#00C087',
  down: '#ea0070',
  upLight: 'rgba(0,192,135,0.15)',
  downLight: 'rgba(234,0,112,0.15)',
  shallowDigitOpacity: 0.5,
  highlight: '#f5bc00',
  chartTheme: 'chart-black-bnb',
  depthTheme: 'depth-black-bnb',
  fontColor: '#fff',
  fontColor1: '#afafaf',
  fontColor2: '#999',
  fontColor3: '#666',
  fontColor5: '#d4d4d4',
  formsbg: '#262626',
  inputBorder: '#333',
  formsHeaderbg: 'transparent',
  inputBg: '#212833',
  heading: '#fff',
  loadingShadeColor: '#1A2132',
  errorInputBg: 'transparent',
  errorInputBorderColor: '#ef4b5a',
  tooltipBg: '#666',
  counterColor: '#f5bc00',
  bnbBurning: '#e8b342',
  bnbBurnClose: '#aaa',
  xfersLogoBoxBg: '#23448E',
  lineColor: '#f0f0f0',
  sectionBg: '#1e2126',
  sectionBorderRadius: '4px',
  sectionBoxShadow: '-4px 4px 10px 0px rgba(0,0,0,0.1)',
  radioBg: '#1e273a',
  buyButtonBg: 'linear-gradient(90deg, rgba(0, 192, 135, 1), rgba(65, 222, 221, 1))',
  sellButtonBg: 'linear-gradient(90deg, rgba(234, 0, 112, 1), rgba(252, 84, 179, 1))',
  scrollbarBg: '#12161c',
  scrollbarTrackColor: '#252d38',
  scrollbarThumbColor: '#848e9c',
  tableOddRowBg: '#1b2027',
  tableRowHoverBg: '#252d38',
  tableRowHoverTextColor: '#fff',
  bestAskBidColor: 'currentColor',
  bestAskBidDecoration: 'underline',
  exchangeSectionTitleColor: '#f0b90b',
  exchangeTabSelectedColor: '#f0b90b',
  exchangeTabSelectedBg: 'rgba(240, 185, 11, 0.15)',
  exchangeTabSelectedContent: 'none',
  exchangeTabNotSelectedColor: '#848e9c',
  inputPlaceholderColor: '#848e9c',

  tradingViewStyle,
  tradingViewCssPath: '/static/tradingview/themes/tv-dark-theme-v1.min.css',
  tradingViewClipPath: 'inset(1px 2px 1px 1px)',

  tradingViewOverrides: {
    volumePaneSize: 'medium', // large, medium, small, tiny
    'paneProperties.background': tradingViewStyle.bg,
    'symbolWatermarkProperties.transparency': 85,
    'scalesProperties.backgroundColor': '#151a1e',
    'scalesProperties.textColor': tradingViewStyle.textColor,

    'paneProperties.vertGridProperties.color': tradingViewStyle.grid,
    'paneProperties.horzGridProperties.color': tradingViewStyle.grid,
    'paneProperties.crossHairProperties.color': tradingViewStyle.crosshair,
    'scalesProperties.lineColor': tradingViewStyle.lineColor,
    'symbolWatermarkProperties.color': 'rgba(0, 0, 0, 0)',

    'mainSeriesProperties.style': 1,

    //  Candles styles
    'mainSeriesProperties.candleStyle.upColor': tradingViewStyle.long,
    'mainSeriesProperties.candleStyle.downColor': tradingViewStyle.short,
    'mainSeriesProperties.candleStyle.drawWick': true,
    'mainSeriesProperties.candleStyle.drawBorder': true,
    'mainSeriesProperties.candleStyle.borderColor': '#C400CB',
    'mainSeriesProperties.candleStyle.borderUpColor': tradingViewStyle.long,
    'mainSeriesProperties.candleStyle.borderDownColor': tradingViewStyle.short,
    'mainSeriesProperties.candleStyle.wickUpColor': tradingViewStyle.long,
    'mainSeriesProperties.candleStyle.wickDownColor': tradingViewStyle.short,

    'study_Overlay@tv-basicstudies.barStyle.upColor': 'blue',
    'study_Overlay@tv-basicstudies.barStyle.downColor': 'blue',

    'study_Overlay@tv-basicstudies.lineStyle.color': 'blue',

    'study_Overlay@tv-basicstudies.areaStyle.color1': 'blue',
    'study_Overlay@tv-basicstudies.areaStyle.color2': 'blue',
    'study_Overlay@tv-basicstudies.areaStyle.linecolor': 'blue',
  },
  emergencyNotice: {
    wrapBg: '#212121',
    boxBg: '#3d3d3d',
    dotColor: '#f5bc00',
    titleColor: '#fff',
    detailLinkColor: '#f5bc00',
  },
  FormRow: {
    MaxQuantityBoxBg: '#f3ba2e',
    MaxQuantityBoxColor: '#333',
    FiatPriceBoxBg: '#1d1d1d',
    FiatPriceBoxColor: 'white',
  },
  // todo: fix colours for dark theme.
  Modal: {
    modalTitleBg: '#fff',
    modalTitleFontColor: '#fff',
    modalBoxBg: '#666',
    okButtonBg: '#f0b90b',
    okButtonColor: '#fff',
    okButtonBorderColor: '#f0b90b',
    cancelButtonBg: '#999',
    cancelButtonColor: '#fff',
    cancelButtonBorderColor: '#999',
  },
  Download: {
    bg: 'transparent',
  },
  miniSymbolsFiatPrice: {
    bg: '#666',
    color: '#fff',
    shadowColor: 'rgba(51,51,51,0.3)',
    linkHoverColor: '#e8b342',
  },
}
